import { makeImmerReducer } from './utils';

/**
 * Keep track of global UI state.
 */
export interface LocationState {
  /** True if the keyboard-shortcut-help modal should be shown. */
  accessibilities: { [locationId: string]: boolean };
}

export const initialState: LocationState = {
  accessibilities: {},
};

export const locationReducer = makeImmerReducer(initialState, (draft, action) => {
  switch (action.type) {
    case 'TEST_LOCATION_ACCESSIBILITY':
      draft.accessibilities[action.deviceId] = action.isAccessible;
      break;
  }
});
